module.exports = __webpack_public_path__ + "img/not-authorized.f34cc5b9.svg";